export default __webpack_public_path__ + "static/media/AlabamaHouseBG.4fb1c7e9.jpg";